<template>
  <section class="content">
    <admin-header
      :title="'Locations'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    >
      <div slot="buttons" @click="clearCache" class="btn btn-danger sq" data-toggle="tooltip" title="Route Optimisation caches Locations to increase performance; click here to clear this cache following Location updates used in Optimised routes">
        Refresh Cache
      </div>
    </admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  import URLS from '../../../../api/endpoints'
  import event from '../../../../event'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminLocation',
    data () {
      return {
        newEntityScreen: 'Admin - Locations',
        searchEntityScreen: 'Admin - Location search',
        filterEventName: 'admin-location-filter',
        filterName: 'LocationFilter',
        entityName: 'location'
      }
    },
    methods: {
      clearCache () {
        this.$http.delete(URLS.OPTI_CACHE)
          .then(() => event.$emit('toast', { message: 'Cached cleared', type: 'success' }))
          .catch(() => event.$emit('toast', { message: 'Cached error', type: 'error' }))
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Location/AdminLocation.vue